var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5362 7.53794V15.0322M6.55137 10.6606V15.0322C6.55137 16.026 7.34095 16.9791 8.7464 17.6819C10.1519 18.3846 12.0581 18.7794 14.0457 18.7794C16.0333 18.7794 17.9395 18.3846 19.345 17.6819C20.7504 16.9791 21.54 16.026 21.54 15.0322V10.6606M25.8117 8.68956C26.0353 8.59092 26.2251 8.42885 26.3575 8.22342C26.4899 8.01799 26.5591 7.77824 26.5566 7.53386C26.554 7.28948 26.4799 7.05121 26.3433 6.84856C26.2067 6.64592 26.0136 6.4878 25.788 6.39381L15.0824 1.51751C14.7569 1.36906 14.4034 1.29224 14.0457 1.29224C13.688 1.29224 13.3344 1.36906 13.009 1.51751L2.3046 6.38881C2.08223 6.4862 1.89306 6.64628 1.76022 6.84948C1.62738 7.05267 1.55664 7.29018 1.55664 7.53294C1.55664 7.7757 1.62738 8.01321 1.76022 8.2164C1.89306 8.4196 2.08223 8.57968 2.3046 8.67707L13.009 13.5584C13.3344 13.7068 13.688 13.7836 14.0457 13.7836C14.4034 13.7836 14.7569 13.7068 15.0824 13.5584L25.8117 8.68956Z",
    stroke: "#882960",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.25b71e785d6bed0b1236bc6a410f682c.svg";
export { ForwardRef as ReactComponent };